export const API_URL = process.env.REACT_APP_FMPRP_API_URL;
export const APP_URL = process.env.REACT_APP_FMPRP_ORIGIN;
export const ACCESS_TOKEN_LOCAL_STORAGE_KEY = 'jwt';
export const ACCESS_TOKEN_QUERY_PARAM = 'token';
export const AUTHORIZATION_ERROR_QUERY_PARAM = 'authorizationError';
export const API_OAUTH2_LOGIN_URL = `${process.env.REACT_APP_FMPRP_API_URL}/oauth2/authorization/google`;
export const AUTHORIZATION_HEADER = `Bearer ${localStorage.getItem(ACCESS_TOKEN_QUERY_PARAM)}`;

export const IS_PROD_ENV = `${process.env.REACT_APP_ENV_IS_PROD}`;
